import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { submitSeatSelectionStep } from '%paysera_seat_selection_integration/js/seatings/redux';
import SubmissionBlock from './SubmissionBlock';

const styles = ({ spacing }) => ({
    root: {
        margin: spacing(2, -1),
    },
});

export default compose(
    connect(
        null,
        dispatch => ({
            submitStep: () => dispatch(submitSeatSelectionStep()),
        }),
    ),
    withStyles(styles),
)(SubmissionBlock);
